import { saveToCache, getFromCache } from "./../utils/idb";
import { fetchWithAuth } from "./../utils/api";
import { transformApiResponse } from "./apiTransformer";
import { addDataToMap } from "kepler.gl/actions";

export const fetchAndProcessInfractionData = async (setLayerDataState, dispatch, store) => {
    let transformed;
    try {

        const INFRACTION_CACHE_KEY = "infraction-get-evidences";
        const INFRACTION_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

        let forceRefresh = false;

        const cachedData = await getFromCache(INFRACTION_CACHE_KEY);
        const cachedTime = localStorage.getItem(INFRACTION_CACHE_KEY + "-timestamp");

        let data;

        if (!forceRefresh && cachedData && cachedTime && (Date.now() - cachedTime < INFRACTION_CACHE_DURATION)) {

            console.log("Using cached data", { forceRefresh, cachedData, cachedTime });
            data = cachedData; // Serve from cache
        } else {
            const response = await fetchWithAuth("https://be-lb.chitragupta.co/get-evidences");
            data =  await response.json();
            await saveToCache(INFRACTION_CACHE_KEY, data);
            localStorage.setItem(INFRACTION_CACHE_KEY + "-timestamp", Date.now());
        }

        console.log("Sujeet transformApiResponse data", data)
        transformed = transformApiResponse(data);
        setLayerDataState((prev) => ({ ...prev, infraction: transformed }));
        console.log("Sujeet transformed useEffect start", transformed);
    } catch (err) {
        console.error("Error getting infraction api reponse / cache", err);
        transformed = {};
    }

    // Store the fetched data in Redux
    dispatch({ type: 'STORE_TRANSFORMED_EVIDENCE_DATA', payload: transformed });

    console.log("Sujeet transformApiResponse transformed", transformed);

    dispatch(
        addDataToMap({
            datasets: [
                {
                    info: { label: "Evidences", id: "evidence" },
                    data: transformed
                }
            ],
            options: {
                centerMap: false,
                readOnly: false,
                keepExistingConfig: true
            },
            config: {
            visState: {
                interactionConfig: {
                    tooltip: {
                        id: 'tooltip',
                        enabled : true,
                        compareMode: false,
                        compareType: "absolute",
                        fieldsToShow: {
                            evidence : [
                                { name: 'Infraction Type', format: null },
                                { name: 'Vehicle Type', format: null }
                            ]
                        }
                    },
                    geocoder: {
                        enabled: true
                    }
                },
                layers: [
                    {
                        "id": "h5kymjs",
                        "type": "point",
                        "config": {
                        "dataId": "evidence",
                        "columnMode": "points",
                        "label": "Infraction",
                        "color": [
                            248,
                            149,
                            112
                        ],
                        "highlightColor": [
                            252,
                            242,
                            26,
                            255
                        ],
                        "columns": {
                            "lat": "latitude",
                            "lng": "longitude"
                        },
                        "isVisible": true,
                        "visConfig": {
                            "radius": 15,
                            "fixedRadius": false,
                            "opacity": 0.8,
                            "outline": false,
                            "thickness": 2,
                            "strokeColor": null,
                            "colorRange": {
                            "colors": [
                                "#12939A",
                                "#DDB27C",
                                "#88572C",
                                "#FF991F",
                                "#F15C17",
                                "#223F9A",
                                "#DA70BF",
                                "#125C77",
                                "#4DC19C",
                                "#776E57",
                                "#17B8BE",
                                "#F6D18A",
                                "#B7885E",
                                "#FFCB99",
                                "#F89570",
                                "#829AE3",
                                "#E79FD5",
                                "#1E96BE",
                                "#89DAC1",
                                "#B3AD9E"
                            ],
                            "name": "Uber Viz Qualitative",
                            "type": "qualitative",
                            "category": "Uber"
                            },
                            "strokeColorRange": {
                            "name": "Global Warming",
                            "type": "sequential",
                            "category": "Uber",
                            "colors": [
                                "#4C0035",
                                "#880030",
                                "#B72F15",
                                "#D6610A",
                                "#EF9100",
                                "#FFC300"
                            ]
                            },
                            "radiusRange": [
                            0,
                            50
                            ],
                            "filled": true,
                            "billboard": false,
                            "allowHover": true,
                            "showNeighborOnHover": false,
                            "showHighlightColor": true
                        },
                        "hidden": false,
                        },
                        // visualChannels: {
                        //     colorField: {
                        //         name: "label_class",
                        //         format: "",
                        //         type: "string",
                        //         analyzerType: "STRING",
                        //         fieldIdx: 0,
                        //         id: "label_class",
                        //         displayName: "label_class"
                        //     },
                        // }
                    }
                ]
            }
            }
        })
    );
    console.log("Current Map Configuration:", store.getState());
    console.log("Sujeet transformedData useEffect end", transformed);
};